import React, { useState } from "react";
import { auth } from "../../actions/firebase";

const FindPassword = ({ history }) => {
  const [email, setEmail] = useState("");

  const onFormSubmit = async (event) => {
    event.preventDefault();
    try {
      await auth.sendPasswordResetEmail(email);
      alert(`${email}로 이메일을 전송하였습니다.`);
      history.push("/login");
    } catch (e) {
      if (e.code === "auth/user-not-found") {
        alert("이메일이 올바르지 않습니다.");
      } else {
        alert("이메일 전송이 실패하였습니다.");
      }
    }
  };

  return (
    <div className="find-password">
      <form className="find-pw-form mt-1" onSubmit={onFormSubmit}>
        <h3>비밀번호 재설정</h3>
        <p className="txt-gray txt-center font-bold">
          이메일로 비밀번호를 재설정 할 수 있는 링크를 보내 드립니다. <br />
          이메일을 확인해주세요.
        </p>
        <div className="input-area pt-3">
          <input
            className="form-control mb-3 p-4 font-bold"
            type="text"
            placeholder="이메일"
            value={email}
            maxLength="30"
            onChange={(event) => setEmail(event.target.value)}
          />
        </div>
        <button className="btn btn-lg btn-blue mb-2 font-bold" type="submit">
          확인
        </button>
        <span className="txt-gray float-right font-small font-bold">
          고객센터 070-7114-0418
        </span>
      </form>
    </div>
  );
};

export default FindPassword;
